var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"active":_vm.value,"width":_vm.width,"full-screen":_vm.fullScreen,"can-cancel":_vm.canCancel,"custom-class":"is-sheet","animation":"sheetLeft"},on:{"update:active":function($event){return _vm.$emit('input', $event)}}},[_c('div',{staticClass:"modal-sheet-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }